module.exports = __webpack_public_path__ + "img/dvojluzkovy_pokoj_jidelni_kout_1.8f2bdc5f.jpg";